import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import NavBar from '../../../_minha-central/NavBar/index'
import Footer from '../../../_minha-central/Footer/index'
import NRTMenu from '../../Menu'
import {withAppContext} from "../../AppContext"


class NRTAppContainer extends React.Component {


    state = {
        sidebarOpen: false
    }

    render() {
        const {sidebarOpen} = this.state

        const {
            className,
            children,
            style,
            //logo,
            title
        } = this.props

        const {
            credentials,
            systemConfigParameterValue
        } = this.props.context

        return (
            <div className={className}>
                <div className={'nrt-app-container'} style={style}>
                    {
                        this.props.showHeader && (
                            <header>
                                <NavBar logoImgSrc={systemConfigParameterValue.logo}
                                        title={title}
                                        schema={credentials.schema}
                                        history={this.props.history || null}
                                        context={this.props.context}
                                />
                            </header>
                        )
                    }

                    <main id={'page-wrap'}>
                        {children}
                    </main>

                    {
                        this.props.showFooter && (
                            <footer>
                                <Footer
                                    logoImgSrc={this.props.context.systemConfigParameterValue.logo}
                                    systemParams={this.props.context.systemParams}/>
                            </footer>
                        )
                    }

                    <NRTMenu open={sidebarOpen}/>
                </div>
            </div>
        )
    }
}


NRTAppContainer.propTypes = {
    style: PropTypes.object,
    showHeader: PropTypes.bool,
    showFooter: PropTypes.bool,
    className: PropTypes.string,
    history: PropTypes.object,
    context: PropTypes.object,
}

NRTAppContainer.defaultProps = {
    showHeader: true,
    showFooter: true
}

export default withAppContext(NRTAppContainer)



// WEBPACK FOOTER //
// ./src/components/_common/_containers/AppContainer/index.js